import { debounce, throttle } from '../debounce'

interface SquashCallbackOptions {
  debounce?: number
  throttle?: number
}

export function squashCallback<T = any>(
  callback: (args: NoInfer<T[]>) => void,
  options?: SquashCallbackOptions
): (arg: T, ...args: any[]) => void {
  let args: T[] = []
  const trigger = () => {
    callback(args)
    args = []
  }
  const debounceTrigger = options?.throttle
    ? throttle(trigger, options.throttle)
    : debounce(trigger, options?.debounce ?? 0)
  return (arg) => {
    args.push(arg)
    debounceTrigger()
  }
}
